<template>
    <UDropdown
        v-if="auth.user"
        :items="links"
        :popper="{
            placement: 'bottom-end',
        }"
        :ui="{
            item: { disabled: 'cursor-text select-text' },
            width: 'w-64',
        }"
    >
        <UAvatar size="md" :alt="auth.user.name" :src="auth.user.avatar" />

        <template #account>
            <div class="text-left">
                <p class="truncate text-base text-gray-900 dark:text-white">
                    {{ auth.user.name }}
                </p>
                <p class="truncate text-sm font-medium text-gray-900 dark:text-white">
                    {{ auth.user.email }}
                </p>
            </div>
        </template>

        <template #item="{ item }">
            <span class="truncate">{{ item.label }}</span>
            <UIcon :name="item.icon" class="flex-shrink-0 h-4 w-4 text-gray-400 dark:text-gray-500 ms-auto" />
        </template>
    </UDropdown>
</template>

<script setup lang="ts">
import { app, platform } from '@todesktop/client-core'

const auth = useAuthStore()

const isDesktopApp = computed(() => platform.todesktop.isDesktopApp())

const links = [
    [
        { label: '', slot: 'account', disabled: true }
    ],
    [
        { label: 'Change password', icon: 'i-ph-lock-duotone', click: onChangePassword },
        { label: isDesktopApp.value ? 'Sign out & quit app' : 'Sign out', icon: 'i-ph-sign-out-duotone', click: onLogout }
    ],
]

function onChangePassword() {
    navigateTo('/password/reset')
}

async function onLogout() {
    await auth.logout()
    if (isDesktopApp.value) {
        await app.quit()
    }
    navigateTo('/login')
}
</script>
